import { CapoPlugin } from "C:/Users/zreat/Documents/Projects/ludmilaphoto/node_modules/.pnpm/@unhead+vue@1.11.13_vue@3.5.13/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];